export enum OnyxMapRoutePointVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
